/**
 * AboutPage — /about spoke route.
 * PLACEHOLDER bio — Sakib must provide content before production go-live.
 */
import { Helmet } from 'react-helmet-async';
import { Link } from '@tanstack/react-router';
import SchemaJsonLd from '../components/primitives/SchemaJsonLd.jsx';
import Eyebrow from '../components/ui/Eyebrow.jsx';
import Button from '../components/ui/Button.jsx';
import Reveal from '../components/ui/Reveal.jsx';
import { aboutHead, bio, partnerLine, aboutCta, aboutLinks } from '../content/about.js';

const aboutPersonSchema = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  '@id': 'https://artificersai.com/#sakib',
  name: 'Sakib Rahman',
  jobTitle: 'Founder',
  description: 'Perth-based AI systems founder. Building AI-native business systems for operating businesses worldwide.',
  worksFor: { '@type': 'Organization', name: "The Artificer's AI", url: 'https://artificersai.com/' },
  url: 'https://artificersai.com/about',
};

const aboutBreadcrumb = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://artificersai.com/' },
    { '@type': 'ListItem', position: 2, name: 'About', item: 'https://artificersai.com/about' },
  ],
};

export default function AboutPage() {
  return (
    <>
      <Helmet>
        <title>Sakib Rahman — Founder, The Artificer's AI</title>
        <meta name="description" content="Perth-based AI systems founder. Building AI-native systems for operating businesses worldwide." />
        <link rel="canonical" href="https://artificersai.com/about" />
        <meta property="og:title" content="Sakib Rahman — Founder, The Artificer's AI" />
        <meta property="og:description" content="Perth-based AI systems founder. Building AI-native systems for operating businesses worldwide." />
        <meta property="og:url" content="https://artificersai.com/about" />
      </Helmet>

      <section className="section-pad bg-surface text-ink-50">
        <div className="container-page max-w-prose">
          <Reveal as="div" delay={0} className="mb-4">
            <Eyebrow>{aboutHead.eyebrow}</Eyebrow>
          </Reveal>
          <Reveal as="h1" delay={80} className="text-display-lg font-display font-semibold mb-4">{aboutHead.heading}</Reveal>
          <Reveal as="p" delay={160} className="text-body-lg text-ink-200 mb-8">{aboutHead.subheading}</Reveal>
          <Reveal as="div" delay={220}>
            {bio.paragraphs.map((p, i) => (
              <p key={i} className="text-body text-ink-200 mb-4">{p}</p>
            ))}
          </Reveal>
          <Reveal as="p" delay={280} className="text-body-sm text-ink-300 mt-8">{partnerLine}</Reveal>
        </div>
      </section>

      <section className="section-pad bg-surface-alt text-ink-50 border-t border-white/[.06]">
        <div className="container-page max-w-prose">
          <div className="flex flex-col gap-4 mb-10">
            {Object.values(aboutLinks).map((link, i) => (
              <Reveal key={link.href} as="div" delay={i * 80}>
                <Link to={link.href} className="text-body text-brand-blue-bright hover:text-brand-blue-pale transition-colors">
                  {link.label}
                </Link>
              </Reveal>
            ))}
          </div>
          <Reveal as="div" delay={Object.values(aboutLinks).length * 80}>
            <Button as={Link} to="/intake">{aboutCta.label}</Button>
          </Reveal>
        </div>
      </section>

      <SchemaJsonLd data={aboutPersonSchema} />
      <SchemaJsonLd data={aboutBreadcrumb} />
    </>
  );
}
